import { Route, RouteProps, Routes, BrowserRouter } from 'react-router-dom';
import { ContentSurveyView, Home, SurveyView, RatingSelectionView } from './views';

export enum AppRoutes {
    HOME = '/',
    SURVEY = '/review',
    CONTENT = '/content',
    RATING_SELECTION = '/rating-selection',
}

const routes: RouteProps[] = [
    { path: AppRoutes.HOME, element: <Home /> },
    { path: AppRoutes.SURVEY, element: <SurveyView /> },
    { path: AppRoutes.CONTENT, element: <ContentSurveyView /> },
    { path: AppRoutes.RATING_SELECTION, element: <RatingSelectionView /> },
    { path: '*', element: <Home /> },
];

export const Router = () => (
    <BrowserRouter>
        <Routes>
            {routes.map((route, i) => (
                <Route key={i} {...route} />
            ))}
        </Routes>
    </BrowserRouter>
);
